import React, { useState } from 'react';
import Bio from './Bio';

const Hero = () => {
  const [audioPlaying, setAudioPlaying] = useState(false);
  const [audio, setAudio] = useState(null);

  const playAudio = () => {
    if (!audioPlaying) {
      const newAudio = new Audio('assets/floating-abstract.mp3');
      newAudio.play();
      setAudio(newAudio);
      setAudioPlaying(true);
    } else {
      audio.pause();
      setAudioPlaying(false);
    }
  };
  return (
    <main className='hero-container' id='home'>
      <div className='brandtext'>
        <div className='flex-layout'>
          <div
            data-aos='fade-right'
            className='hero-media-animation bio-position'
          >
            <Bio />
          </div>
          <div className='hero-media-hello'>
            <h1
              onClick={playAudio}
              className='hero-heading  hover-underline-animation'
              data-aos='fade-left'
            >
              Hello
            </h1>
          </div>
        </div>
        <div className='mystack-cont-row '>
          <h2
            className='hero-cont-h2 auto-underline-animation anime-grad'
            data-aos='flip-up'
            data-aos-delay='500'
            data-aos-duration='500ms'
          >
            Eat
          </h2>
          <h2
            className='hero-cont-h2 '
            data-aos='flip-up'
            data-aos-delay='750'
            data-aos-duration='700ms'
            style={{ backgroundColor: '#d6581e' }}
          >
            Sleep
          </h2>
          <h2
            className='hero-cont-h2 autotwo-underline-animation  anime-grad'
            data-aos='flip-up'
            data-aos-delay='750'
            data-aos-duration='700ms'
          >
            Dev
          </h2>
          <h2
            className='hero-cont-h2'
            data-aos='flip-up'
            data-aos-delay='800'
            data-aos-duration='760ms'
            style={{ backgroundColor: '#d6581e' }}
          >
            Deploy
          </h2>
          <h3
            className='hero-cont-h2 auto-underline-animation  anime-grad'
            data-aos='flip-up'
            data-aos-delay='1350'
            data-aos-duration='760ms'
          >
            repeat
          </h3>
        </div>
      </div>
    </main>
  );
};

export default Hero;
